import TidalEffect from "effects/midi/TidalEffect.js";
import {eq, and} from './compare.js';
import {BOTH, NONE} from '../jaki/constants.js';
import {doc} from './documentation.js';
import {print} from './log.js';
import {t_len} from './tlist.js';
import {s, trigger, p, filter, lazy} from './lang.js';
import MidiTrigger from "effects/midi/MidiTrigger.js";
import {parse, getCycleString} from 'effects/midi/tidal/parser.js';

doc(
    "tidal",
    {
        "pattern": "",
        "cycleLength": "",
        "accentFactor": "",
        "cycleRetrigger": "",
    },
    "Plays a tidal pattern"
);
export const tidal = (pattern, cycleLength, accent=2, cycleRetrigger=false) => {
    let tidalEffect = undefined;
    let _pattern = undefined;
    let _patternString = undefined;

    return (... args) => {
        let [stepData, stepNumber, time, effect] = args;
        if (!tidalEffect) {
            tidalEffect = effect.useTidal();
        }


        let lpattern = lazy(pattern, ...args) || [];
        if (lpattern !== _pattern) {
            if (typeof lpattern === "string") {
                let _parsed = parse(pattern);
                tidalEffect.cycleParameter.set(_parsed, true, true);
            } else if (Array.isArray(lpattern)) {
                if (!_patternString || _patternString !== getCycleString(lpattern)) {
                    if (tidalEffect.cycle !== lpattern) {
                        tidalEffect.cycleParameter.set(lpattern, true, true);
                    }
                }
            }
            _pattern = lpattern;
            _patternString = getCycleString(_pattern);
        }

        let _cycleLength = lazy(cycleLength, ...args);
        if (_cycleLength === undefined) {
            _cycleLength = 32; 
        }
        if (_cycleLength !== tidalEffect.cycleLength) {
            tidalEffect.cycleLengthParameter.set(_cycleLength, true, true);
        }
        let _accent = lazy(accent, ...args);
        if (_accent !== tidalEffect.accentFactor) {
            tidalEffect.accentFactorParameter.set(_accent, true, true);
        }
        let _cycleRetrigger = lazy(cycleRetrigger,...args);
        if (_cycleRetrigger !== tidalEffect.cycleRetrigger) {
            tidalEffect.cycleRetrigger = _cycleRetrigger;
        }
        
        if (stepData) {
            let midiTrigger = new MidiTrigger(stepData, time, stepNumber);
            tidalEffect.input(midiTrigger);
        }
        let triggers = tidalEffect.output(
            time, stepNumber, stepNumber);

        if (triggers.length === 0) {
            return filter(false);
        }

        return s(trigger(triggers));
    };
};

export const tparse = (pattern) => {
    let last = undefined;
    let evaled = undefined;
    return (...args) => {
        let _pattern = lazy(pattern, ...args);
        if (_pattern  === last) {
            return evaled;
        }
        evaled = parse(_pattern);
        last = _pattern;
        return evaled;
    };
};

export const t_print = (x) => {
    return (...args) => {
        let _x = lazy(x, ... args);
        return print(getCycleString(_x))(...args);
    };
};

export const t_cond = (condition, p1, p2) => {
    return (...args) => {
        let _condition = lazy(condition, ...args);
        let _p1 = lazy(p1, ...args);
        let _p2 = lazy(p2, ...args);
        if (typeof _condition === "object") {
            _condition = _condition.value;
        }
        return _condition ? _p1 : _p2;
    };
};

doc(
    "hand",
    {
        handType: ""
    },
    "Filters triggers generated by tidal by hand (left=false right=true)"
);
export const hand = (handType=true) => {
    return (...args) => {
        let [stepData, stepNumber] = args;
        if (args[3].zObject.sequencerEngine.isSequenceRolling) {
            // we wanna force retrigger these
            return filter(true);
        }
        if (!stepData) {
            return filter(false);
        }
        if (stepData.isDouble) {
            return filter(true);
        }
        let _hand = stepData.hand ? 1 : 0;
        let _handType = Math.round(lazy(handType, ...args));
        if (_handType === BOTH) {
            return filter(true);
        } else if (_handType === NONE) {
            return filter(false);
        }
        return filter(
            _hand === _handType);
    };
};

export const j_tidal = (pattern, factor, triplet) =>
    tidal(
        t_cond(eq(triplet, true),
               makeTriplet(pattern), // if triplet=true make the triple
               pattern),
        t_len(pattern, factor, triplet));

const makeTriplet = (pattern) => {
    return (...args) => {
        // need to slice of a lot the pattern;
        let _pattern = lazy(pattern, ...args);

        let x = _pattern.slice(0, Math.floor(_pattern.length * 3/4));
        return x;
    };
};
